import PublicLayout from "@/components/public/PublicLayout";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export default function GSTBilling() {
  const points = [
    "Tax invoices with company logo, GSTIN, HSN/SAC codes",
    "Automatic CGST + SGST or IGST split based on place of supply",
    "GST calculator (inclusive/exclusive) with 0%, 3%, 5%, 12%, 18%, 28% support",
    "HSN summary report grouped by tax rate",
    "GSTR-1 and GSTR-3B ready data exports",
    "Credit notes and debit notes with matching series numbering",
    "Reverse charge and place-of-supply handling",
    "Auto invoice numbering with financial year (e.g. INV/2026-27/0001)",
  ];
  return (
    <PublicLayout>
      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">GST-ready billing<br />that just works.</h1>
          <p className="mt-4 text-muted-foreground text-lg">Every invoice you generate is compliant, auto-calculated, and ready to share.</p>
          <ul className="mt-8 space-y-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm">
                <Check size={16} className="text-primary flex-shrink-0 mt-0.5" /> {p}
              </li>
            ))}
          </ul>
          <div className="mt-8"><Button asChild size="lg"><Link to="/signup">Start Billing Free</Link></Button></div>
        </div>
        <Card className="p-8 bg-muted/40">
          <div className="rounded-lg border bg-background p-6 shadow-sm text-sm">
            <div className="text-center font-heading font-bold text-lg">TAX INVOICE</div>
            <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
              <div><div className="text-muted-foreground">Invoice #</div><div className="font-semibold">INV/2026-27/0142</div></div>
              <div className="text-right"><div className="text-muted-foreground">Date</div><div className="font-semibold">18 Aug 2026</div></div>
            </div>
            <div className="mt-4 border-t pt-3">
              <div className="text-muted-foreground text-xs">BILL TO</div>
              <div className="font-semibold">Sample Customer</div>
              <div className="text-xs text-muted-foreground">GSTIN 27AAAAA0000A1Z5 · Maharashtra</div>
            </div>
            <table className="w-full mt-4 text-xs">
              <thead>
                <tr className="bg-muted">
                  <th className="p-2 text-left">Item</th>
                  <th className="p-2 text-right">HSN</th>
                  <th className="p-2 text-right">Qty</th>
                  <th className="p-2 text-right">Amt</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b"><td className="p-2">Interior Service</td><td className="p-2 text-right">9954</td><td className="p-2 text-right">1</td><td className="p-2 text-right">₹10,000</td></tr>
                <tr className="border-b"><td className="p-2">Product 001</td><td className="p-2 text-right">7318</td><td className="p-2 text-right">2</td><td className="p-2 text-right">₹1,200</td></tr>
              </tbody>
            </table>
            <div className="mt-3 flex justify-end">
              <div className="w-40 text-xs space-y-1">
                <div className="flex justify-between"><span>Subtotal</span><span>₹11,200</span></div>
                <div className="flex justify-between"><span>CGST 9%</span><span>₹1,008</span></div>
                <div className="flex justify-between"><span>SGST 9%</span><span>₹1,008</span></div>
                <div className="border-t pt-1 flex justify-between font-bold"><span>Total</span><span>₹13,216</span></div>
              </div>
            </div>
          </div>
        </Card>
      </section>
    </PublicLayout>
  );
}
